import React, { Component } from 'react';
import axios from 'axios';
import NumberFormat from 'react-number-format';
import { Row, Col, Icon, Card, Divider } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import moment from 'moment'
import { Offline, Online } from "react-detect-offline";
import { Alert } from 'antd';
import Image from 'react-image-resizer';

const API_HOST_URL = process.env.REACT_APP_API_URL


const { compose, withProps, lifecycle } = require("recompose");
const {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  DirectionsRenderer,
} = require("react-google-maps");

const MapLoader = compose(
    withProps({
      googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyCZ-lrgcyu8rNUArDpZuWSEPVoLBBNt2zE&v=3.exp&libraries=geometry,drawing,places",
      loadingElement: <div style={{ height: `100%` }} />,
      containerElement: <div style={{ height: `400px` }} />,
      mapElement: <div style={{ height: `100%` }} />,
    }),
    withScriptjs,
    withGoogleMap,
  
    lifecycle({
      componentDidMount() {
        // console.log("map props:",this.props.location)
  
        const DirectionsService = new window.google.maps.DirectionsService();
        // const{origin_lat, origin_lng, destination_lat, destination_lng} = this.props;
        console.log("map props: ", this.props)

        // console.log("origin_lat", from_latitude);
        // console.log("origin_lng", from_longitude);
        // console.log("destination_lat", to_latitude);
        // console.log("destination_lng",to_longitude);
  
        DirectionsService.route({
            origin: {lat: this.props.location.from_latitude, lng: this.props.location.from_longitude},//new google.maps.LatLng(41.8507300, -87.6512600),
            destination: {lat: this.props.location.to_latitude, lng: this.props.location.to_longitude },//new google.maps.LatLng(41.8525800, -87.6514100),
            travelMode: window.google.maps.TravelMode.DRIVING,
        }, (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            this.setState({
              directions: result,
            });
          } else {
            console.error(`error fetching directions ${result}`);
          }
        });
      }
    })
  )(props =>
    <GoogleMap
      defaultZoom={7}
      defaultCenter={{lat: 0.347596, lng: 32.582520}}//{new google.maps.LatLng(41.8507300, -87.6512600)}
    >
      {props.directions && <DirectionsRenderer directions={props.directions} />}
    </GoogleMap>
  );

class TripDetailForDriver extends Component {
    state = {
        trip: {}
      }
    
    componentDidMount(){
        const tripId = this.props.match.params.tripId;
        console.log("TripId: ",tripId);
        axios.get(`${API_HOST_URL}/api/trips/${tripId}/?expand=user`)
        .then(res => {
            this.setState({
            trip: res.data
            })

            console.log("trip data: ", res.data);
        })
    }

    // googleDistance(){
    //     const DirectionsService = new window.google.maps.DistanceMatrixService((res,status)=>{
    //         console.log(res);
    //     });
    // }
 
  render() {
      const { trip } = this.state;
      
    return (
        <div>
            {
                this.props.location.state ? (this.props.location.state.showSuccessMessage &&
            <Alert
                showIcon 
                message="Your Trip successfully created!"
                type="success"
                closable
                />) : ''
            }
            {/* <MainHeader/> */}
            <Card>
                <Row>
                    {/* <Col md={{span: 4, offset: 3}}>
                        <img src={userProfile} style={{height: '60%', width: '60%'}} alt="logo" />
                        <h3 style={{fontWeight: "bold"}} className="GrayText">Gilbert</h3>
                        <h4 style={{fontWeight: "bold", color: '#0099ff'}}>
                        <Icon type="star" theme="filled" />5.0 &nbsp;
                        <span style={{fontWeight: "normal", color: '#0099ff'}}>5 Reviews</span>
                        </h4>
                        
                    </Col> */}
                    <Col md={{span: 12, offset: 3}}>
                        <h1 style={{color: '#0099ff'}}>
                           {trip.originCity} to {trip.destinationCity}
                        </h1>
                        <Row>
                            <Col md={{span: 6}}>
                                <h3 style={{fontWeight: "bold"}} className="GrayText">Leaving</h3>
                            </Col>
                            <Col md={{span: 16}}>
                                <h3 style={{fontWeight: "bold"}} className="GrayText">
                                {moment(trip.departureDate).format('dddd, D MMMM YYYY')} at {moment(trip.departureTime, "HH:mm").format("hh:mm A")}
                                </h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={{span: 6}}>
                                <h3 style={{fontWeight: "bold"}} className="GrayText"><span id="icon_from"></span>Pickup</h3>
                            </Col>
                            <Col md={{span: 16}}>
                                <h3 style={{fontWeight: "normal"}} className="GrayText">{trip.originCity}</h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={{span: 6}}>
                                <h3 style={{fontWeight: "bold"}} className="GrayText">Dropoff</h3>
                            </Col>
                            <Col md={{span: 16}}>
                                <h3 style={{fontWeight: "normal"}} className="GrayText">{trip.destinationCity}</h3>
                            </Col>
                        </Row>
                        {/* <Row>
                            <Col md={{span: 6}}>
                                <h3 style={{fontWeight: "bold"}} className="GrayText">Distance</h3>
                            </Col>
                            <Col md={{span: 16}}>
                                <h3 style={{fontWeight: "normal"}} className="GrayText">200km (5h travel time)</h3>
                            </Col>
                        </Row> */}
                        <Row>
                            <Col md={{span: 22}}>
                                <h3 style={{fontWeight: "normal"}} className="GrayText">
                                    {trip.tripDescription}
                                </h3>
                            </Col>
                        </Row>
                    </Col>
                    {/* <Col md={{span: 6}}>
                        <Card>
                            <Row>
                                <Col md={{span: 16}}>
                                    <img src={carImage} style={{height: '90%', width: '90%'}} alt="logo" />
                                </Col>
                                <Col  md={{span: 8}}>
                                    <h4 className="GrayText">Subaru</h4>
                                    <h4 style={{fontWeight: "normal"}} className="GrayText"> 2010</h4>
                                    <h4 style={{fontWeight: "normal"}} className="GrayText">Silver</h4>
                                </Col>
                            </Row>
                            <Divider/>
                            
                            <h4 style={{fontWeight: "normal"}} className="GrayText">
                            <Icon type="shopping" theme="filled" /> Small Luggage ok</h4>
                            
                        </Card>
                    </Col> */}
                    <Col md={{span: 6}}>
                        <Card>
                            <Row>
                                <Col md={{span: 16}}>
                                    {/* <img src={carImage} style={{height: '90%', width: '90%'}} alt="logo" /> */}
                                    <Image
                                      src={(trip.user && trip.user.primary_vehicle.length > 0) && (API_HOST_URL + (trip.user && trip.user.primary_vehicle[0].vehiclePhoto))}
                                      height={100}
                                      width={150}
                                      // style={style.vehicleImage}
                                        />
                                </Col>
                                <Col  md={{span: 8}}>
                                    <h4 style={{fontWeight: "bold"}} className="GrayText"> { trip.user && trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].numberPlate}</h4>
                                    <h4 className="GrayText">{ trip.user && trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].vehicleModel}</h4>
                                    <h4 style={{fontWeight: "normal"}} className="GrayText">{ trip.user && trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].color}</h4>
                                </Col>
                            </Row>
                            <Divider/>
                            
                            <h4 style={{fontWeight: "normal"}} className="GrayText">
                            <Icon type="shopping" theme="filled" style={{color: `${(trip.user && trip.user.primary_vehicle.length && trip.user.primary_vehicle[0].lagguageAllowed == 'No') ? 'red': 'green'}`}} /> {trip.user && trip.user.primary_vehicle.length && trip.user.primary_vehicle[0].lagguageAllowed} Luggage allowed</h4>
                            
                        </Card>
                        </Col>
                </Row>
            </Card>
            <Row style={{backgroundColor: "#0099ff"}}>
                    <Col md={{span: 12, offset: 3}} >
                        <Card bordered={false} style={{backgroundColor: "#0099ff"}}>
                            <h3 style={{color: "#ffffff"}}>Booked: {trip.numberOfSeatsBooked}</h3>
                        </Card>
                    </Col>
                    {/* <Col md={{span: 8}} >
                        <Card bordered={false} style={{backgroundColor: "#0099ff"}}>
                            <Button size="large" type="primary" style={{backgroundColor: "#ff3d00", borderWidth: '0px'}}>
                                <Link to="/book-trip">Book Now</Link>
                            </Button>
                        </Card>
                    </Col> */}
                    <Col md={{span: 6 }}>
                        <Card bordered={false} style={{backgroundColor: "#1275b5"}}>
                            <Row>
                                <Col md={{span: 8}}>
                                    <h3 style={{color: "#ffffff"}}><span style={{fontSize: '1.5em'}}>{trip.numberOfSeats}</span> seats left</h3>
                                </Col>
                                <Col md={{span: 16}}>
                                    <h3 style={{color: "#ffffff"}}>
                                        <span style={{fontSize: '1.5em'}}>
                                            <NumberFormat value={trip.pricePerSeat} displayType={'text'} thousandSeparator={true} prefix={'Ush '}/>
                                        </span>
                                        <span> per seat</span>
                                    </h3>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
            </Row>
            <Row>
            <Col md={{span:24}} >
                              <div>
                                <Online>
                                    <MapLoader location={{ from_latitude: parseFloat(this.state.trip.originLatitude), from_longitude: parseFloat(this.state.trip.originLongitude), to_latitude: parseFloat(this.state.trip.destinationLatitude), to_longitude: parseFloat(this.state.trip.destinationLongitude) }}/>
                                </Online>
                                <Offline>You are not connected to the internet. Connect to the internet to see the maps!</Offline>
                              </div>
                            }
                        </Col>
            </Row>
            
          
        </div>
    );
  }
}


export default TripDetailForDriver;
